<template>
  <div>
    <SlideShowSection />
    <HighlightMenuSection />
    <StudentMenuSection />
    <ProjectsSection />
    <ArticlesSection />
    <GalleriesSection />
  </div>
</template>

<script>
import SlideShowSection from "../components/sections/SlideShowSection.vue";
import HighlightMenuSection from "../components/sections/HighlightMenuSection.vue";
import StudentMenuSection from "../components/sections/StudentMenuSection.vue";
import ProjectsSection from "../components/sections/ProjectsSection.vue";
import ArticlesSection from "../components/sections/ArticlesSection.vue";
import GalleriesSection from "../components/sections/GalleriesSection.vue";

export default {
  components: {
    SlideShowSection,
    HighlightMenuSection,
    StudentMenuSection,
    ProjectsSection,
    ArticlesSection,
    GalleriesSection,
  },
};
</script>
